import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {ContentService} from '../../services/content.service';
import {Answer} from '../../models/answer';
import {QuestionControlService} from '../../services/question-control.service';
import {QuestionService} from '../../services/question.service';
import {FormControl, FormGroup} from '@angular/forms';
import {QuestionBase} from '../../models/question-base';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
  providers: [QuestionService, QuestionControlService, ContentService]
})
export class ContactComponent implements OnInit {

  public unique: any;
  public data: any;
  private answers: Answer;

  public questions: any[];
  public question: QuestionBase<any>[] = [];
  form: FormGroup;
  payLoad = '';
  public successMessage: boolean;

  constructor(private _route: ActivatedRoute,
              private _router: Router,
              private qcs: QuestionControlService,
              private _questionsService: QuestionService,
              private _service: ContentService) {
    this.successMessage = false;
  }

  /**@author Lupita Llamas
   * Trae la info de las preguntas
   */
  ngOnInit() {
    this.form = new FormGroup({
      firstName: new FormControl()
    });
    this._route.params.forEach((paramas: Params) => {
      this.unique = paramas['unique'];
    });
    if (this.unique !== 'undefined' || this.unique !== '') {
      this._service.questionsData(this.unique).subscribe(result => {
        this.data = result;

          this.questions = this._questionsService.getQuestions(this.data.questions);
          this.form = this.qcs.toFormGroup(this.questions);
      }, err => {
        if (err.status === 404) {
          this._router.navigate(['']); // Customer didn't found
        } else if (err.status === 400) {
          this._router.navigate(['err400']); // Customer with card inactive
        } else {
          this._router.navigate(['']); // Another mistake
        }
      }
      );
    } else {
        this._router.navigate(['']); // Customer didn't found
    }
  }

  /**@author Lupita Llamas
   * Boton que toma lo del formulario y lo envia al ws de enviar correo
   */
  onSubmit(id: string) {
    this.answers = new Answer('', '', {});
    this.answers.unique_id = this.unique;
    this.answers.email = this.data.email;
    this.answers.answers = this.form.value;
    this._service.sendEmail(this.answers).subscribe(result => {
      console.log('enviado');
      this.successMessage = true;

      /*this.modalService.open('contact-succes');*/
    }, err => {
      if (err.status === 404) {
        console.log('404');
      } else {
        console.log('505');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/contact/contact.component.ts